function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.665 0H1.335C.599 0 0 .601 0 1.34v1.826c0 .253.204.457.455.457h.026v8.037c0 .739.598 1.34 1.335 1.34h10.369c.736 0 1.334-.601 1.334-1.34V3.623h.026A.456.456 0 0014 3.166V1.34C14 .601 13.401 0 12.665 0zM.91 1.34c0-.235.19-.426.425-.426h11.33c.234 0 .425.191.425.426v1.37H.91V1.34zm4.564 2.283h3.052v4.221l-1.312-.7a.457.457 0 00-.428 0l-1.312.7v-4.22zm7.135 8.037c0 .235-.19.426-.424.426H1.815a.425.425 0 01-.424-.426V3.623h3.172v4.981a.458.458 0 00.669.404L7 8.065l1.768.943a.456.456 0 00.668-.404v-4.98h3.173v8.036z",
  fill: "#333",
  fillRule: "nonzero"
});

function SvgProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgProduct;